import React from 'react';
import './Card1.css'


import image6 from '../../img/projects/scenezen.png';
import image7 from '../../img/projects/gsmbd.png';
import image8 from '../../img/projects/xber.png';
import image9 from '../../img/projects/laliga.png';
import image0 from '../../img/projects/pogba.png';
import image11 from '../../img/projects/hungry.png'

const Card1 = () => {
    return (

        <div id="card" className="cardSection">
            <h1 className="projects-title">Some of my Projects</h1>
            
            <div className="row">


                <div className=" card-area col-lg-4 col-md-6 d-flex justify-content-center my-5">
                <div className="card" style={{width: '18rem'}}>
                <img src={image6} className="w-100" alt=""/>
                    <div className="mx-auto">
                        <h5 className="card-title">Scenezen Films</h5>
                    </div>
                   <p className="card-text px-2">This is a film and media-related website, If any company wanted to make their TVC, OVC, etc. They can booking, making payments after booking, and give reviews through this website. Admin can update new services through the admin panel.</p>
                    <div class="mx-auto my-0">
                        <a href="https://scenezenfilms.web.app/ " target="_blank" className="card-link">Live Link</a>
                        <a href="https://github.com/shahin1122/scenezenfilms-project-clint" target="_blank" className="card-link">Code</a>
                    </div> 
                    </div>

                </div>





                <div className=" card-area col-lg-4 col-md-6  d-flex justify-content-center my-5">
                <div className="card" style={{width: '18rem'}}>
                <img src={image7} className="w-100" alt=""/>
                    <div className="mx-auto">
                        <h5 className="card-title">GSM BD</h5>
                    </div>
                   
                   
                    <p className="card-text px-2">This is a tech website, buyers can buy a new and updated phone using this website. But before buying they have to log in to this website and after that they can see their review details. And in the admin panel, the admin can add a new phone to this website. </p>
                    <div class="mx-auto my-0">
                        <a href="https://gsmbd-c0193.web.app/" target="_blank" className="card-link">Live</a>
                        <a href="https://github.com/shahin1122/gsmbd-project-clint" className="card-link" target="_blank">Code</a>
                    </div>
                    </div>

                </div>




                <div className="card-area col-lg-4 col-md-6  d-flex justify-content-center my-5">
                <div className="card " style={{width: '18rem'}}>
                <img src={image8} className="w-100" alt=""/>
                    <div className="card-body">
                        <h5 className="card-title">Xber Ride</h5>
                       
                    </div>
                    <p className="card-text px-2">This is a ride-sharing website, users can use it for transport purposes, They can select a specific vehicle. For selecting a vehicle and confirming the ride user have to log in through this website and after login user selected the route and see the vehicle. </p>
                   
                    <div class="mx-auto mb-5">
                        <a href="https://urban-riders-c24c7.web.app/" target="_blank" className="card-link">Live</a>
                        <a href="https://github.com/shahin1122/xberRide-project" className="card-link" target="_blank">Code</a>
                    </div>
                    </div>

                </div>





                <div className= "card-area col-lg-4 col-md-6  d-flex justify-content-center my-5">
                <div className="card" style={{width: '18rem'}}>
                <img src={image9} className="w-100" alt=""/>
                    <div className="card-body">
                        <h5 className="card-title">La Liga</h5>
                        <p className="card-text">La Liga is a football club-related website. Anyone who wants to know the club detail they can visite this side and there are lots of clubs show the home page, If a user wants to see a specific club detail then user click the button and then the user can know the detail about the club.  </p>
                    </div>
                   
                    <div class="mx-auto mb-5">
                        <a href="https://lucid-wescoff-5b0e95.netlify.app/" target="_blank" className="card-link">Live</a>
                        <a href="https://github.com/shahin1122/La-liga" className="card-link" target="_blank">Code</a>
                    </div>
                    </div>

                </div>




                <div className="card-area col-lg-4 col-md-6  d-flex justify-content-center my-5">
                <div className="card" style={{width: '18rem'}}>
                <img src={image0} className="w-100" alt=""/>
                    <div className="card-body">
                        <h5 className="card-title">Uropa Footbal Club</h5>
                        <p className="card-text">Europa football team is a functional website, user or manager can buy a specific player and all players budget show under the profile and if manger wants to buy multiple players for making a new club the can add the player and, mangers selected player total budget show in the heading.</p>
                    </div>
                   
                    <div class="mx-auto mb-5">
                        <a href="https://elastic-agnesi-aeacf5.netlify.app/" target="_blank" className="card-link">Live</a>
                        <a href="https://github.com/Porgramming-Hero-web-course/simple-react-shahin1122" className="card-link" target="_blank">Code</a>
                    </div>
                    </div>

                </div>





                <div className="card-area col-lg-4 col-md-6  d-flex justify-content-center my-5">
                <div className="card" style={{width: '18rem'}}>
                <img src={image11} className="w-100" alt=""/>
                    <div className="card-body">
                        <h5 className="card-title">Hungry Monstar</h5>
                        <p className="card-text">Hungry monster is a javascript API project, I use fetch API to call a specific data to form mealDB, user how wants to buy some food and he can search food from this website and if a user wants to know the food detail then the user can click specific food card then he can see the detail of this food. and he can order food if he wants (coming soon)</p>
                    </div>
                   
                    <div class="mx-auto mb-5">
                        <a href="https://shahin1122.github.io/hungryMonstar1/ " target="_blank" className="card-link">Live</a>
                        <a href="https://github.com/shahin1122/hungryMonstar1" target="_blank" className="card-link">Code</a>
                    </div>
                    </div>

                </div>




          

            </div>
            <hr/>



           


           



            
            
        </div>
    );
};

export default Card1;